import { AfterContentInit, Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { EIMLTypeSubstratMineral } from 'src/app/domain/IML/enum/type-substrat-mineral';
import { EIMLTypeSubstratVegetal } from 'src/app/domain/IML/enum/type-substrat-vegetal';
import { IMLProcess } from 'src/app/domain/IML/IML-process';
import { Substrat } from 'src/app/domain/IML/substrat';
import { EBloomAlgal } from 'src/app/domain/Lac - EAU/enum/bloom-algal';
import { EIntensiteVent } from 'src/app/domain/Lac - EAU/enum/intensite-vent';
import { EPresenceMarnage } from 'src/app/domain/Lac - EAU/enum/presence-marnage';
import { ESigneEmergence } from 'src/app/domain/Lac - EAU/enum/signe-emergence';
import { ESurfaceEau } from 'src/app/domain/Lac - EAU/enum/surface-eau';
import { Limpidite } from 'src/app/domain/SANDRE/limpidite';
import { EMeteo } from 'src/app/domain/SANDRE/meteo';
import { VisibiliteFond } from 'src/app/domain/SANDRE/visibilite-fond';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { IMLService } from 'src/app/services/iml-service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { IMLSubstratBoxComponent } from 'src/app/tools/ui/iml-substrat-box/iml-substrat-box.component';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-iml',
    templateUrl: './iml.component.html',
    styleUrls: ['./iml.component.scss']
})
export class IMLComponent implements OnInit, AfterContentInit {

    EPresenceMarnage = EPresenceMarnage;
    public IntensiteVentList: string[] = Object.values(EIntensiteVent).filter(x => !isNaN(Number(x))).map(x => StringConverter.getIntensiteVent(x as EIntensiteVent));
    public SurfaceEauList: string[] = Object.values(ESurfaceEau).filter(x => !isNaN(Number(x))).map(x => StringConverter.getSurfaceEauName(x as ESurfaceEau));
    public MeteoList: string[] = Object.values(EMeteo).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMeteoName(x as EMeteo));
    public BloomAlgalList: string[] = Object.values(EBloomAlgal).filter(x => !isNaN(Number(x))).map(x => StringConverter.getBloomAlgalName(x as EBloomAlgal));
    public PresenceMarnageList: string[] = Object.values(EPresenceMarnage).filter(x => !isNaN(Number(x))).map(x => StringConverter.getPresenceMarnageName(x as EPresenceMarnage));

    public LimpiditeList: string[] = Object.values(Limpidite).filter(x => !isNaN(Number(x))).map(x => StringConverter.getLimpiditeName(x as Limpidite));

    public VisibiliteFondList: string[] = Object.values(VisibiliteFond).filter(x => !isNaN(Number(x))).map(x => StringConverter.getVisibiliteName(x as VisibiliteFond));
    public SigneEmergenceList: string[] = Object.values(ESigneEmergence).filter(x => !isNaN(Number(x))).map(x => StringConverter.getSigneEmergenceName(x as ESigneEmergence));

    AmplitudeMarnageControl = new UntypedFormControl('', Validators.min(0));
    HauteurVagueControl = new UntypedFormControl('', Validators.min(0));
    ProfondeurControl = new UntypedFormControl('', Validators.min(0));
    IMLProcess: IMLProcess = new IMLProcess();

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        public CoreData: CoreData,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private imlService: IMLService) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.update();
            }
        })
    }

    ngOnInit(): void {
    }

    async ngAfterContentInit(): Promise<void> {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        if (this.CoreData.IsOffline) {

            this.IMLProcess = Object.assign(new IMLProcess(), this.CoreData.getOfflineProcess(this.route.snapshot.params.processCode));
            this.IMLProcess.Code = this.route.snapshot.params.processCode;
        } else {
            this.IMLProcess = await this.imlService.getIMLProcessByCode(this.route.snapshot.params.processCode).toPromise();
        }
    }

    getIMLTypeSubstratMineralName(mat: EIMLTypeSubstratMineral) {
        return StringConverter.getIMLSubstratMineralName(mat);
    }

    getIMLTypeSubstraVegetalName(mat: EIMLTypeSubstratVegetal) {
        return StringConverter.getIMLSubstratVegetalName(mat);
    }

    openIMLSubstratDialog(sub: Substrat) {
        const dialogRef = this.dialog.open(IMLSubstratBoxComponent, {
            data: sub,
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Substrat) => {
            if (result) {
                sub = result;
                NotificationManager.handleSuccess('Substrat modifié', this.snackBar);
            }
        });
    }

    update() {
        if (this.CoreData.IsOffline) {
            this.CoreData.setOfflineProcess(this.IMLProcess);
            NotificationManager.handleSuccess('Prestation enregistrée', this.snackBar);
        } else {
            this.imlService.updateProcess(this.IMLProcess).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Prestation enregistrée', this.snackBar);
                }
            });
        }
    }
}
